import React from 'react';
export const Emoji = ({ children }) => (React.createElement("span", { className: 'inline-text-emoji', "data-testid": 'inline-text-emoji' }, children));
